import { useSelector } from 'react-redux';

import { DefaultSpinnerCenter } from '@components/Loader/Loader';
import { PlanPricingOutboundTable } from '@components/Order/Numbers/Tables';
import { Page500 } from '@containers/ErrorPages';
import { planDetailsApi } from '@reducers/plan';
import { skipToken } from '@reduxjs/toolkit/query';

export const OutboundRatesTab = () => {
  const { showState } = useSelector((state) => state.plan.planInfo);
  const queryArg =
    showState.currentPlan.id && showState.currentPlan.type
      ? { ...showState.currentPlan }
      : skipToken;
  const { data, isLoading, isFetching, isError } =
    planDetailsApi.useGetOutboundRatesQuery(queryArg);
  if (isLoading || isFetching) {
    return <DefaultSpinnerCenter />;
  }
  if (isError) {
    return <Page500 />;
  }
  return <PlanPricingOutboundTable data={data.rates} plan={data.plan} />;
};
